<template>
  <v-dialog
    v-model="localDialog"
    width="50%"
    persistent
    transition=""
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>{{ isEntryMode ? "Add Leave Type" : "Update Leave Type" }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="leaveTypeSetup">
          <v-row>
            <!-- Name -->
            <v-col lg="6" md="6" cols="12">
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="code.value.value"
                :error-messages="code.errorMessage.value"
                clearable
              >
                <template #label>
                  Code <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>
            </v-col>

            <!-- Max Days -->
            <v-col lg="6" md="6" cols="12">
              <v-text-field
                label="Max Days"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="max_days.value.value"
                :error-messages="max_days.errorMessage.value"
                clearable
              >
                <template #label>
                  Max Days <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>
            </v-col>

            <!-- Remarks -->
            <v-col lg="6" md="6" cols="12">
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="name.value.value"
                :error-messages="name.errorMessage.value"
                clearable
              >
                <template #label>
                  Full Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>
              
            </v-col>

            <!-- Carry Forward Switch -->
            <v-col lg="6" md="6" cols="12" >
              <v-textarea
                label="Remarks (Optional)"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="remarks.value.value"
                :error-messages="remarks.errorMessage.value"
                clearable
                auto-grow
                rows="1"
              ></v-textarea>

              <v-switch
                v-model="carry_forward.value.value"
                :true-value="1"
                :false-value="0"
                color="primary"
                inset
                hide-details
              >
                <template #label>
                  Carry Forward <span class="text-red-accent-4">*</span>
                </template>
              </v-switch>
            </v-col>

            <!-- Active Status -->
            <v-col cols="12">
              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                hide-details
                color="primary"
                :true-value="1"
                :false-value="0"
              ></v-checkbox>
            </v-col>

          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
              >
                Close
              </v-btn>
              <v-btn
                class="bg-brand w-15 ms-2"
                variant="flat"
                type="submit"
              >
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { ref, watch } from "vue";
  import { useStore } from "vuex";
  import { useField, useForm } from "vee-validate";
  import * as yup from "yup";
  import { toast } from "vue3-toastify";
  import { fileServerUrl } from "@/store/api";

  export default {
    name: "leaveTypeSetup",
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => ({
          id: "",
          code: "",
          name: "",
          max_days: "",
          carry_forward: 0,
          remarks: "",
        }),
      },
    },
    data() {
      return {
        localDialog: this.dialog,
        isEntryMode: true,
        preview: "/src/assets/no_preview.jpeg",
      };
    },
    watch: {
      dialog(val) {
        this.localDialog = val;
      },
      localDialog(val) {
        this.$emit("update:dialog", val);
      },
      data: {
        handler(newData) {
          console.log(newData)
          this.isEntryMode = !newData.id;
          this.resetForm({ errors: {}, touched: {} });

          this.name.setValue(newData.name || "", false);
          this.code.setValue(newData.code || "", false);
          this.max_days.setValue(newData.max_days || "", false);
          this.carry_forward.setValue(Number(newData.carry_forward) || 0, false);
          this.remarks.setValue(newData.remarks || "", false);
          this.status.setValue(Number(newData.status) ??  1, false);
          this.leave_type_id.setValue(newData.id || "", false);
        },
        immediate: true,
      },
    },
    methods: {
      closeDialog() {
        this.$emit("update:dialog", false);
      },
    },
    setup(props, { emit }) {
      const { handleSubmit, resetForm } = useForm({
        validationSchema: yup.object({
          name: yup.string().min(1).max(50).required().trim().label("Name"),
          max_days: yup.number().required().label("Max Days"),
          carry_forward: yup.number().required().label("Carry Forward"),
          remarks: yup.string().max(250).nullable().trim().label("Remarks"),
        }),
      });

      const name = useField("name");
      const code = useField("code");
      const max_days = useField("max_days");
      const carry_forward = useField("carry_forward");
      const remarks = useField("remarks");
      const status = useField("status");
      const leave_type_id = useField("leave_type_id");

      const store = useStore();
      const loading = ref(false);

      const submit = handleSubmit((values) => {
        loading.value = true;
        store
          .dispatch("saveUpdateLeaveType", values)
          .then((response) => {
            resetForm();
            emit("update:dialog", false);
            toast.success(response.data.message);
            store.dispatch("getLeaveTypeList").finally(() => {
              loading.value = false;
            });
          })
          .catch((error) => {
            loading.value = false;
            toast.error(error.response?.data?.message || "Something went wrong");
          });
      });

      return {
        submit,
        name,
        code,
        max_days,
        carry_forward,
        remarks,
        status,
        leave_type_id,
        resetForm,
        loading,
      };
    },
  };
</script>


<style scoped>
.slim-switch {
  transform: scale(0.8); /* পুরো switch ছোট */
  margin-top: -8px;
  margin-bottom: -8px;
}

.slim-switch .v-switch__track {
  height: 14px !important; /* track height কমানো */
  border-radius: 7px !important;
}

.slim-switch .v-switch__thumb {
  width: 12px !important;
  height: 12px !important;
}
</style>
